
<div *ngIf="!errorMessage" class="container">
    <iframe  #iframeElement  class="responsive-iframe" src="http://10.222.70.27/"></iframe>
   
</div>
<div *ngIf="errorMessage" class="alert">
    <span class="closebtn" onclick="this.parentElement.style.display='none';">&times;</span> 
    <strong>Error!</strong> Para mostrar el contenido, es necesario conectarse a la red/VPN de Cemex.
  </div>